// search-state.service.ts
import { Injectable } from '@angular/core';

const KEY = 'APR_SEARCH_STATE';

@Injectable({ providedIn: 'root' })
export class AprSearchStateService {
  set(value: any) {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  }
  get(): any | null {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  }
  clear() {
    sessionStorage.removeItem(KEY);
  }
}
